import React from 'react'
import Ink from 'react-ink'
import * as general from '../constants/General'
import * as status from '../constants/Status'
import { connect } from 'react-redux'
import { setFunctionBarType } from '../actions/layoutActions'
import $ from 'jquery'
import PropTypes from 'prop-types'

class TitleBarButton extends React.Component {
  constructor(props) {
    super(props);
    this.handleTouchTap = this.handleTouchTap.bind(this);
    this.handleFunctionBar = this.handleFunctionBar.bind(this);
  }

  handleFunctionBar(functionbartype) {
    let newtype = functionbartype;
    if (this.props.functionbartype === functionbartype) {
      newtype = general.FUNCTIONBAR_NONE;
    }
    this.props.setFunctionBarType(newtype);
  }

  handleTouchTap() {
    switch (this.props.type) {
      case general.TITLEBAR_STATUS:
        this.handleFunctionBar(general.FUNCTIONBAR_STATUS)
        break;
      case general.TITLEBAR_FUNCTION:
        this.handleFunctionBar(general.FUNCTIONBAR_FUNCTION)
        break;
      case general.TITLEBAR_SHOWHIDERECEIPT:
        const mainContainer = $('#main-container');
        const receiptKeyboardContainer = $('#receipt-keyboard-container');
        if (receiptKeyboardContainer.css('display') === 'none') {
          mainContainer.css('display', 'none');
          receiptKeyboardContainer.css('display', 'block');
        } else {
          mainContainer.css('display', 'block');
          receiptKeyboardContainer.css('display', 'none');
        }
        break;
      default:
        break;
    }
  }

  componentDidMount() {
    this.notifyWarning();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.devices !== this.props.devices ||
      prevProps.licensestatus !== this.props.licensestatus
    ) {
      this.notifyWarning();
    }
  }

  notifyWarning() {
    let classname = this.props.icon;
    if (this.props.type === general.TITLEBAR_STATUS) {
      for (let i = 0; i < this.props.devices.length; i++) {
        if (this.props.devices[i].status > status.PRINTER_OK) {
          classname = 'warning sign icon';
        }
      }
      if (this.props.licensestatus === false) {
        classname = 'warning sign icon';
      }
    }
    const warningActive = classname === 'warning sign icon';
    if (this.props.onWarningChange) {
      this.props.onWarningChange(warningActive);
    }
  }

  render() {
    let classname = this.props.icon;
    if (this.props.type === general.TITLEBAR_STATUS) {
      for (let i = 0; i < this.props.devices.length; i++) {
        if (this.props.devices[i].status > status.PRINTER_OK) {
          classname = 'warning sign icon';
        }
      }
      if (this.props.licensestatus === false) {
        classname = 'warning sign icon';
      }
    }
    return (
      <button onClick={this.handleTouchTap} className="titlebar-button">
        <i className={classname}>&nbsp;</i>
        {this.props.text}
        <Ink />
      </button>)
  }
}

TitleBarButton.propTypes = {
  text: PropTypes.string,
  icon: PropTypes.string,
  type: PropTypes.number,
  functionbartype: PropTypes.number,
  devices: PropTypes.array,
  setFunctionBarType: PropTypes.func,
  licensestatus: PropTypes.bool,
  onWarningChange: PropTypes.func,
  warningActive: PropTypes.bool
};

function mapStateToProps(state) {
  return {
    functionbartype: state.layoutState.functionbartype,
    devices: state.generalState.devices,
    licensestatus: state.generalState.licensestatus
  }
}

export default connect(mapStateToProps, { setFunctionBarType })(TitleBarButton)



// WEBPACK FOOTER //
// src/components/TitleBarButton.jsx